import { EyeIcon, StarIcon } from "@heroicons/react/24/outline";
import { FlexCol } from "src/utils/flexLayouts";
import { MouseEvent } from "react";
import { twMerge } from "tailwind-merge";

export type NotifyTypeMobile = "audit" | "owd";

export default function ChooseTypeOfNotifyMobile({
  type,
  onChange,
}: {
  type: NotifyTypeMobile;
  onChange(type: NotifyTypeMobile): void;
}) {
  function handleClick(event: MouseEvent<HTMLButtonElement>) {
    onChange(event.currentTarget.name as NotifyTypeMobile);
  }

  return (
    <section className="px-5 py-4">
      <h4 className="mb-5 text-black text-[18px] leading-[28px] font-medium">
        Выберите тип уведомления
      </h4>
      <FlexCol className="gap-3">
        <button
          type="button"
          name="audit"
          onClick={handleClick}
          className={twMerge(
            type === "audit" ? "border-darkblue" : "border-[#D1D5DB]",
            "w-full min-h-[132px] rounded-lg border p-4 text-start flex items-start gap-3",
          )}
        >
          <div className="shrink-0 pt-0.5">
            <EyeIcon
              width={22}
              height={22}
              color={type === "audit" ? "#012169" : "#9CA3AF"}
            />
          </div>
          <div className="min-w-0">
            <div
              className={twMerge(
                type === "audit" ? "text-darkblue" : "text-[#637381]",
                "mb-1 text-[28px] leading-[36px] font-semibold",
              )}
            >
              Ознакомление
            </div>
            <p className="text-[#8899A8] text-[12px] leading-[16px]">
              Сотрудники должны ознакомиться с документом
            </p>
          </div>
        </button>

        <button
          type="button"
          name="owd"
          onClick={handleClick}
          className={twMerge(
            type === "owd" ? "border-darkblue" : "border-[#D1D5DB]",
            "w-full min-h-[132px] rounded-lg border p-4 text-start flex items-start gap-3",
          )}
        >
          <div className="shrink-0 pt-0.5">
            <StarIcon
              width={22}
              height={22}
              color={type === "owd" ? "#012169" : "#9CA3AF"}
            />
          </div>
          <div className="min-w-0">
            <div
              className={twMerge(
                type === "owd" ? "text-darkblue" : "text-[#637381]",
                "mb-1 text-[28px] leading-[36px] font-semibold",
              )}
            >
              OWD
            </div>
            <p className="text-[#8899A8] text-[12px] leading-[16px]">
              Сотрудники должны провести OWD
            </p>
          </div>
        </button>
      </FlexCol>
    </section>
  );
}
